<template>
    <!-- :style="`width: 100%;height: ${height}px;background: linear-gradient(115deg, #57c9fe, #5777fe);`" -->
        <div id="user_detail">


			<div id="header">
				<el-row class="header" type="flex" justify="center">
					<el-col :span="3" class="logo">
						<!-- <img :src="$store.state.school_logo"> -->
					</el-col>
					<el-col :span="16" class="h_menu_box">
						<el-menu :default-active="activeIndex" class="menu" mode="horizontal">
							<el-menu-item index="userDetail">个人信息</el-menu-item>
						</el-menu>
					</el-col>
					<el-col :span="3" class="headRight">
						<!-- <div v-if="$store.state.visitor" @click="login()" class="loginOut">登录</div> -->
						<!-- v-else -->
						<div  @click="loginOut()" class="loginOut">退出</div>
					</el-col>
				</el-row>
			</div>
            <UserComponent :xuejiInfoDisplay="false" :getMyUserRelation="get_my_user_relation"></UserComponent>
        </div>
        
    </template>
    
    <script>
	import UserComponent from './userCenter/user_component.vue'
	function xuejiTxt(ji){
		switch (ji){
			case 1:
				return "在读"
			case 2:
				return "毕业"
			case 3:
				return "停学"
			case 4:
				return "退学"
		}
	}
    export default {
        name: 'user_detail'
        // ,props:["muban_bol"]
        ,components:{
			UserComponent,
		}
        ,data () {
            return {
                ruleForm: {
			    	profile:{},
			    	grade:{},
			    	major:{},
			    	market:{},
			    	mould:{},
			    	school:{},
			    	org:{},
			    	uname: '',
			    	uphone: '',
			    	area: '',
			    	email: '',
			    	school: '',
			    	grade: '',
			    	cengci: '',
			    	zhuanye: '',
			    	idcard:'',
			    	idcardInput:'',
			    	pass:'',
			    	checkPass:'',
			    	certified:false, //是否已经实名认证
			    	is_certified:2, //是否开启实名认证
			    },
				// user_component_display:false,	//信息显示
				activeIndex:'userDetail',
            }
        }
        ,mounted:function(){
        }
        ,methods:{
            //获取我的详情
		    get_my_user_relation(){
				return new Promise((resolve, reject) => {
					this.$ajax.get(
		    			this.global.serverSrc + this.global.qianzui + '/user_relation/my'
		    		)
		    		.then((res)=>{
            		    let resData = res.data
		    			if(resData.code==0){
		    				this.ruleForm.idcardType = '身份证'
		    				this.ruleForm = Object.assign(this.ruleForm ,resData.data)
		    				if(this.ruleForm.profile.idcard.length <= 15){
		    					this.ruleForm.idcardType = '其他'
		    				}
		    				this.ruleForm.cengci=this.ruleForm.major.major_level_name
		    				this.ruleForm.xuejiSt=xuejiTxt(this.ruleForm.student_status)
		    				this.ruleForm.sex = '保密'
		    				if (this.ruleForm.profile.gender!=0) {
		    					this.ruleForm.sex = this.ruleForm.profile.gender==1?'男':'女'
		    				}
		    				// this.ruleForm.sex=this.$selfjs.getSex(this.ruleForm)
		    				this.ruleForm.is_overseas_chinese_text = this.ruleForm.profile.is_overseas_chinese==1?'是':'否'
		    				this.ruleForm.is_disability_text = this.ruleForm.profile.is_disability==1?'是':'否'
		    				this.ruleForm.is_gangaotai_text = this.ruleForm.profile.is_gangaotai==1?'是':'否'
		    				// console.log(resData.data);
							if (!this.ruleForm.org) {
								this.ruleForm.org = {}
							}
							resolve(this.ruleForm)
							// this.get_majors()
							// this.get_user_relation_files()
            		    } 
		    		})
				})
		    },
			//退出登录
			loginOut(){
				var that=this
				this.$confirm('确认退出登录？')
				.then(_ => {
					let logout_url=this.global.serverSrc + this.global.qianzui + "/login/logout"
					this.$ajax.get(logout_url)
					.then(function(res){
						let resData=res.data;
						if(resData.code==0){
							that.$selfjs.loginOutFn(that, "location")
						}else{
							this.$message.error(resData.message)
							// console.log(resData.message);
						}
					})
				})
				.catch(_ => {
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
			},
            // swmubanFn:function(res){
            //     this.$emit("swmuban",res);		//修改app.vue 的 muban_bol 值
            // }
        }
        ,watch: {
        }
    }
    </script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    <!-- scoped单页面有效属性 -->
    
    <style>
    /* body #app{min-height:100%;} */
    </style>
    <style>
    </style>
    


// WEBPACK FOOTER //
// src/components/user_detail.vue